<template>
  <el-container class="app-layout">
    <el-header class="header">
      <div class="header-logo">服务商管理后台</div>
      <div class="header-right">
        <!-- 用户名称 - 悬浮显示重置密码 -->
        <el-popover
          placement="bottom"
          width="120"
          trigger="hover"
          popper-class="user-popover"
        >
          <div class="user-menu">
            <div class="user-menu-item" @click="handleResetPassword">
              <i class="el-icon-key"></i>
              <span>重置密码</span>
            </div>
          </div>
          <span slot="reference" class="header-logout user-name">
            <i class="el-icon-user-solid"></i>
            {{ userInfo.userName }}
          </span>
        </el-popover>

        <span class="header-logout" @click="handleLogout">
          <i class="el-icon-switch-button"></i>退出登录</span
        >
      </div>
    </el-header>

    <el-container class="page-body">
      <el-aside width="220px" class="aside">
        <Sidebar :menuList="menuList" />
      </el-aside>

      <el-main class="main-content">
        <div class="breadcrumb-wrap">
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item
              v-for="(item, index) in breadcrumbItems"
              :key="index"
              @click="goTo(item.path)"
              style="cursor: pointer"
            >
              {{ item.title }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="view-container">
          <router-view />
        </div>
      </el-main>
    </el-container>

    <!-- ===== 重置密码弹窗 ===== -->
    <el-dialog
      title="重置密码"
      :visible.sync="passwordDialogVisible"
      width="460px"
      :close-on-click-modal="false"
      @closed="handleClosePassword"
    >
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="100px"
        size="small"
      >
        <el-form-item label="旧密码" prop="oldPsd">
          <el-input
            v-model="passwordForm.oldPsd"
            type="password"
            placeholder="请输入旧密码"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPsd">
          <el-input
            v-model="passwordForm.newPsd"
            type="password"
            placeholder="请输入新密码"
            show-password
          ></el-input>
          <div class="form-tip">
            8-16位，大小写字母、数字、特殊符号至少包含2类
          </div>
        </el-form-item>

        <el-form-item label="确认新密码" prop="newPsdSure">
          <el-input
            v-model="passwordForm.newPsdSure"
            type="password"
            placeholder="请再次输入新密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="passwordLoading"
          @click="handleConfirmPassword"
        >
          确认
        </el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { UserLogout, ResetPsd } from "../api/login";
import { mapState } from "vuex";
import Sidebar from "../components/common/Sidebar.vue";

export default {
  name: "Dashboard",
  components: { Sidebar },
  computed: {
    ...mapState("permission", ["menuList"]),

    // 动态生成面包屑数据
    breadcrumbItems() {
      const matched = this.$route.matched;
      const items = [];

      for (const route of matched) {
        if (route.meta && route.meta.title) {
          items.push({
            title: route.meta.title,
            path: route.path,
          });
        }
      }

      return items;
    },
  },
  data() {
    // 密码校验规则
    const validateNewPsd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入新密码"));
        return;
      }
      // 8-16位，大小写字母、数字、特殊符号至少包含2类
      const pattern =
        /^(?![\s])(?=.*[A-Za-z])(?=.*\d|.*[!@#$%^&*()_+\-=\[\]{}|;':",./<>?~`])(?=.*\d|[!@#$%^&*()_+\-=\[\]{}|;':",./<>?~`].*[A-Za-z])[A-Za-z0-9!@#$%^&*()_+\-=\[\]{}|;':",./<>?~`]{8,16}$/;
      if (!pattern.test(value)) {
        callback(
          new Error("密码需8-16位，且大小写字母、数字、特殊符号至少包含2类")
        );
        return;
      }
      callback();
    };

    const validateNewPsdSure = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入新密码"));
        return;
      }
      if (value !== this.passwordForm.newPsd) {
        callback(new Error("两次输入的密码不一致"));
        return;
      }
      callback();
    };

    return {
      userInfo: sessionStorage.getItem("userInfo")
        ? JSON.parse(sessionStorage.getItem("userInfo"))
        : { userName: "管理员" },
      menuTree: [],

      // ===== 重置密码 =====
      passwordDialogVisible: false,
      passwordLoading: false,
      passwordForm: {
        oldPsd: "",
        newPsd: "",
        newPsdSure: "",
      },
      passwordRules: {
        oldPsd: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        newPsd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validateNewPsd, trigger: "blur" },
        ],
        newPsdSure: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: validateNewPsdSure, trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  methods: {
    handleLogout() {
      UserLogout()
        .then((res) => {
          if (res.data.isSuccess) {
            sessionStorage.clear();
            window.location.reload();
            this.$message.success(res.data.message);

            // 重置路由
            const { resetRouter } = require("@/router");
            resetRouter();
            // 重置 Vuex 菜单
            this.$store.commit("permission/SET_MENU_LIST", []);
            this.$router.push("/login");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {
          this.$message.error("退出登录失败，请稍后再试");
        });
    },
    goTo(path) {
      this.$router.push(path);
    },

    // ===== 重置密码 =====
    handleResetPassword() {
      this.passwordForm = {
        oldPsd: "",
        newPsd: "",
        newPsdSure: "",
      };
      this.passwordDialogVisible = true;
    },

    handleClosePassword() {
      this.$refs.passwordForm?.resetFields();
      this.passwordForm = {
        oldPsd: "",
        newPsd: "",
        newPsdSure: "",
      };
      this.passwordLoading = false;
    },

    handleConfirmPassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (!valid) return;

        this.passwordLoading = true;
        const params = {
          oldPsd: this.passwordForm.oldPsd,
          newPsd: this.passwordForm.newPsd,
          newPsdSure: this.passwordForm.newPsdSure,
        };

        ResetPsd(params)
          .then((res) => {
            if (res.data.isSuccess) {
              this.$message.success(res.data.message || "密码修改成功");
              this.passwordDialogVisible = false;
              // 密码修改成功后建议退出登录
              setTimeout(() => {
                this.handleLogout();
              }, 1500);
            } else {
              this.$message.error(res.data.message || "密码修改失败");
            }
          })
          .catch(() => {
            this.$message.error("密码修改失败，请稍后重试");
          })
          .finally(() => {
            this.passwordLoading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
@import "../assets/css/common.css";

.app-layout {
  height: 100vh;
  overflow: hidden;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2a87e1;
  padding: 0 24px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.header-logo {
  color: #fff;
  font-size: 23px;
}

.header-right {
  display: flex;
  align-items: center;
  color: #fff;
}

.header-right span {
  margin-left: 16px;
}

.header-logout {
  font-size: 13px;
  color: #eee;
  cursor: pointer;
}

.user-name {
  cursor: pointer;
  transition: opacity 0.2s;
}

.user-name:hover {
  opacity: 0.8;
}

.page-body {
  height: calc(100vh - 64px);
}

.aside {
  background-color: #ffffff;
  height: 100%;
  overflow: auto;
}

.menu {
  border: none;
}

.breadcrumb-wrap {
  background: #fff;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.main-content {
  padding: 20px;
  background-color: #f2f6fc;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.view-container {
  flex: 1;
  overflow: auto;
  padding-right: 10px;
  max-height: calc(100% - 40px);
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.breadcrumb {
  background: transparent;
}

/* 密码表单提示 */
.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* 弹窗底部 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>

<style>
/* 悬浮菜单样式（非 scoped） */
.user-popover {
  padding: 0 !important;
  min-width: 120px !important;
}

.user-menu {
  padding: 4px 0;
}

.user-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  transition: background 0.2s;
}

.user-menu-item:hover {
  background: #ecf5ff;
  color: #409eff;
}

.user-menu-item i {
  font-size: 14px;
}
</style>